
import {computed, defineComponent, onBeforeUnmount, onMounted} from "vue";
import {useI18n} from "vue-i18n";
import {useToast} from "vue-toastification";
import {dismissRestored, isOffline, justRestored, OFFLINE_BLOCKED_EVENT, savedAt} from "@/core/services/Offline";

// Tells that the server can not be reached, and since when the data on the screen are. A request that changes something
// (a payment, a tariff...) can not be made without the server: a message says so.
export default defineComponent({
  name: "offline-banner",
  setup() {
    const {t, locale} = useI18n();
    const toast = useToast();

    const savedTime = computed(() =>
      new Date(savedAt.value).toLocaleString(locale.value === "ua" ? "uk-UA" : "en-GB", {
        day: "2-digit",
        month: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })
    );

    // one message for a burst of requests
    let lastToast = 0;
    const onBlocked = () => {
      if (Date.now() - lastToast < 3000) return;
      lastToast = Date.now();
      toast.warning(t("offline.needsConnection"));
    };

    onMounted(() => window.addEventListener(OFFLINE_BLOCKED_EVENT, onBlocked));
    onBeforeUnmount(() => window.removeEventListener(OFFLINE_BLOCKED_EVENT, onBlocked));

    return {
      isOffline,
      justRestored,
      savedAt,
      savedTime,
      refresh: () => window.location.reload(),
      dismiss: dismissRestored,
    };
  },
});
